<template>
	<v-container fluid class="fullpage">
		<HelpRoomAmenities />
		<v-layout fill-height column>
			<!--Top Layout -->
			<v-layout class="toplayoutRAListEditor">
		
				<v-toolbar height="70" >
					<v-layout justify-space-between align-center>
						<v-flex grow >
							<v-toolbar-title class="headline mt-2 ml-4">Amenities List Editor</v-toolbar-title>
					  	</v-flex>
					  	<v-flex >
						  	<v-toolbar-title class="topTitle ">	
					  			<v-layout align-center row fill-height>			
									<img src="../../images/ua_block_rgb_3.3c82a4c.png" class="blocka">
									<a href="/" style="text-decoration: none;" :style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
										Interactive Floorplans 
									</a>
							 	</v-layout>
							</v-toolbar-title>	
						</v-flex>
						<v-flex shrink><DBToggleBtn/></v-flex>
						<v-flex shrink>
							<v-btn large icon class="grey--text text--darken-2" 
								@click="$router.push({ name: 'home' })">
								<v-icon large >close</v-icon>
							</v-btn>
						</v-flex>	
					</v-layout>
				</v-toolbar>
			</v-layout>

			<v-layout column class="pt-5 pl-5 pr-1 bottomlayoutRAListEditor" style="width: 100%">
				<v-layout column fill-height justify-start class="RAListOverflow">
					
					<v-flex shrink width="610">
						<v-layout row >
							<v-flex xs4>
								<v-select 
						          :items="listOfLists"
						          item-text="listname"
						          item-value="listname"
						          label="Amenities List"
						          outline
						          return-object
						          @change="listChanged"
						          v-model="selectedList">
						        </v-select>
						    </v-flex>
					        <v-btn 	small fab color="grey lighten-1" 
					        		@click="createListDialog=true"
					        		depressed class="ml-4" style="margin-top: 10px;">
					        		<v-icon>add</v-icon>
					        </v-btn>
					        <v-tooltip right >
		                        <v-btn style="margin-top: -7px;" large fab icon @click="showHelp" slot="activator">
		                            <v-icon>help</v-icon>
		                        </v-btn>
		                        <span>About Room Amenities</span>
		                    </v-tooltip>

				    	</v-layout>
			    	</v-flex>

			        <v-flex>
			        	<v-card v-if="amenitiesListDefinition" 
			        		class="pb-5" width="610" color="grey lighten-4">
				        	<v-toolbar color="indigo darken-3" dark height="80">
				        		<v-toolbar-side-icon @click="toggleMenu"></v-toolbar-side-icon>
						      	<v-toolbar-title width="100%" style="width: 100%;">
						      		<v-layout row align-center justify-space-between>
						      			<v-flex xs6 class="title">List Definition</v-flex>
						      		</v-layout>						      		
								</v-toolbar-title>
						    </v-toolbar>

						    <v-navigation-drawer
							    v-model="drawerMenu" class="indigo lighten-2 py-3" width="350"		      		    
							    style="position: absolute; top: 80px; height: calc(100% - 80px);">
							    <v-list class="pt-0 pl-2" dense>							        

							        <v-list-tile @click="showDeleteAndPurgeDialog=true">
							          	<v-list-tile-action>
							            	<v-icon>delete</v-icon>
							          	</v-list-tile-action>
							          	<v-list-tile-content>
							            	<v-list-tile-title >Delete List Definition and Purge Data</v-list-tile-title>
							          	</v-list-tile-content>
							        </v-list-tile>

							        <v-list-tile @click="showPurgeDialog=true">
							          	<v-list-tile-action>	
							          				<v-btn icon><v-icon>clear</v-icon></v-btn>          									                                
							          	</v-list-tile-action>
							          	<v-list-tile-content>
							            	<v-list-tile-title>Purge Room Data</v-list-tile-title>
							          	</v-list-tile-content>
							        </v-list-tile>

									<v-list-tile @click="exportTable">
							          	<v-list-tile-action>
							            	<v-icon>save_alt</v-icon>
							          	</v-list-tile-action>
							          	<v-list-tile-content>
							            	<v-list-tile-title>Export Room Data</v-list-tile-title>
							          	</v-list-tile-content>
							        </v-list-tile>

							    </v-list>
							</v-navigation-drawer>

							<v-dialog v-model="showPurgeDialog" persistent max-width="390">					                                
                                <v-card class="pl-2 pt-1 pr-2">
                                    <v-card-title class="headline">Confirm Purge Data</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text class="pt-4 body-2">All data collected for this list will be deleted.  The list definition will remain.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" flat @click.native="showPurgeDialog = false">Cancel</v-btn>
                                        <v-btn color="green darken-1" flat 
                                            @click.native="showPurgeDialog = false; clearRoomData()">Purge
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>

                            <v-dialog v-model="showDeleteAndPurgeDialog" persistent max-width="390">					                                
                                <v-card class="pl-2 pt-1 pr-2">
                                    <v-card-title class="headline">Confirm List Deletion</v-card-title>
                                    <v-divider></v-divider>
                                    <v-card-text class="pt-4 body-2">All data collected for this list and the list definition will be deleted.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="green darken-1" flat @click.native="showDeleteAndPurgeDialog = false">Cancel</v-btn>
                                        <v-btn color="green darken-1" flat 
                                            @click.native="showDeleteAndPurgeDialog = false; deleteListDefinition()">Purge
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
						
							<v-layout column class="ml-2" v-if="amenitiesListDefinition"  
								style="margin-right: 30px;  ">

								<v-layout v-show="!showChangeOwner" column class="subheading ml-3 mr-1 mt-4" >
									<v-layout row fill-height align-center justify-space-between >				
										<v-flex xs6>
											<v-text-field box label="List Name" @change="changed = true"
							        			v-model="amenitiesListDefinition.listname">
										    </v-text-field>
										</v-flex>
							        	<v-flex xs6>						        		
							        		<v-text-field class="ml-4" box reverse label="Owner" 
							        			@click="showChangeOwner=true"
							        			v-model="amenitiesListDefinition.name">
										    </v-text-field>
										</v-flex>
							        </v-layout>
							        <v-layout row fill-height align-center justify-space-between >	
							        	<v-text-field class="" box label="Editors" 
							        			v-show="!showChangeEditors"
							        			@click="showChangeEditors=true"
							        			:value="getEditors">
										    </v-text-field>										    
							        </v-layout>
						    	</v-layout>

						        <v-flex class="ml-3 mt-4 mb-4" v-if="showChangeOwner">
						        	<span class="caption">Change Owner</span>
						        	<v-btn icon small ><v-icon small color="red lighten-2" @click="showChangeOwner=false">close</v-icon></v-btn>
							        <EmployeeAutocomplete  v-on:return-employee="setOwner"
										label="Change Owner by Name, Empl Num, or NetID"
										:soloinverted="true" 
										/>
								</v-flex>

								<v-flex class="ml-3 mb-4" v-if="showChangeEditors">
						        	<span class="caption">Change Editors</span>
						        	<v-btn icon small ><v-icon small color="red lighten-2" @click="showChangeEditors=false">close</v-icon></v-btn>
							        <EmployeeAutocomplete  
							        	v-on:return-employee="addEditor"
							        	class="mb-2"
										label="Add Editors by Name, Empl Num, or NetID"
										:soloinverted="true" 
										:key="resetEditorAutoComplete"/>										
											
										<v-chip v-for="(item, index) in amenitiesListDefinition.editors" :key="index">{{item.name}}
											<v-icon class="ml-1" small color="red lighten-2"
												@click="removeEditor(index)">close</v-icon>
										</v-chip>
											
										
									
								</v-flex>
								<v-layout v-if="permissionsChanged" row class="ml-3 mr-1 mb-2">
							    	<v-flex class="mr-3"><v-btn color="#a70000" dark block class="" @click="submit">Save Changes</v-btn></v-flex>
							    	<v-flex><v-btn color="#a70000" dark block @click="cancel">Cancel</v-btn></v-flex>
								</v-layout>

						        <v-divider></v-divider>
								<span class="ml-3 mt-2">Room Amenities</span>
								<v-layout class="subheading ml-3 mr-3 mt-4" row fill-height align-center justify-space-between >
									<v-flex xs1>Order</v-flex>
									<v-flex xs6>Label</v-flex>
						        	<v-flex xs5>Data Type</v-flex>
						        </v-layout>

								<div v-for="(item, index) in sortedItems" :key="index" >	
						    		<v-layout 
						    			class="py-1 pl-2"
						    			row fill-height align-center justify-space-between >
						    			<v-flex xs1 class="text-xs-center">

						    				<v-icon @click="changeOrder(index, 'up')" style="position: relative; top: 6px;">expand_less</v-icon>
						    				<!-- {{item.order}} -->
						        			<v-icon @click="changeOrder(index, 'down')" style="position: relative; top: -6px;">expand_more</v-icon>

			      						</v-flex>	
						        		<v-flex xs6>
						        			<v-text-field class="pl-2 mr-2"
						        			v-model="item.label"
						        				:label="item.label ? '' : 'Label'"
									            box
									            autofocus
									            @change="changed = true"
									            hide-details>
									        </v-text-field>
			      						</v-flex>
						        		<v-flex xs5>
						        			<v-select class=""
							        			v-model="item.dataType"
							        			:label="item.dataType ? '' : 'Data Type'"
									          	:items="dataTypes"
									          	box
									          	hide-details
									          	@change="changed = true"
									          	@keyup.enter="addLine(item)">
								           	</v-select>
				    					</v-flex>
				    					<v-flex xs1>
				    						<v-tooltip top>
					    						<v-btn slot="activator" icon @click="deleteItem(index)"><v-icon  color="red lighten-2">close</v-icon></v-btn>
					    						<span>Remove and Clear Associated Data</span>
				    						</v-tooltip>
				    					</v-flex>
						        	</v-layout>
						        	<v-layout class="mb-3" row v-if="item.dataType=='Allowed Values'">
						        		<v-flex xs6></v-flex>
				    					<v-flex xs5 class="ml-5 pr-4">
				    						<v-layout v-for="(item2, index) in item.allowedValues" :key="index" >
				    							<v-flex>
				    								<v-text-field 
									        			v-model="item2.value"
									        			placeholder="New Value"
									        			@keyup.enter="addAllowedValue(item)"
									        			@change="changed = true"
									        			autofocus			            
											            hide-details>
											        </v-text-field>
											    </v-flex>
										        <v-flex xs1>
						    						<v-tooltip top>
							    						<v-btn slot="activator" icon @click="deleteAllowedValue(item, index)"><v-icon small color="red lighten-2">close</v-icon></v-btn>
							    						<span>Delete</span>
						    						</v-tooltip>
						    					</v-flex>
				    						</v-layout>
				    						<v-btn class="ml-0 mt-3" icon outline small color="grey darken-1"
				    							@click="addAllowedValue(item)">
				    							<v-icon>add</v-icon>
				    						</v-btn>
				    					</v-flex>
				    					<v-flex xs1></v-flex>
				    				</v-layout>
						        </div>				        
							    
							    <v-btn ref="addRowBtn" class="ml-3 mt-3" icon small @click="addLine" color="grey lighten-2"><v-icon>add</v-icon></v-btn>

							    <v-layout v-if="changed" row class="ml-3 mr-1">
							    	<v-flex class="mr-3"><v-btn color="#a70000" dark block class="mt-4 mx" @click="submit">Save Changes</v-btn></v-flex>
							    	<v-flex><v-btn color="#a70000" dark block class="mt-4 mx-0" @click="cancel">Cancel</v-btn></v-flex>
								</v-layout>

							</v-layout>
						</v-card>
					</v-flex>
				</v-layout>
			</v-layout>
		</v-layout>

		<v-dialog width="500" v-model="createListDialog" >
        	<v-card class="pl-2 pt-1 pr-2">
		        <v-card-title class="headline">Create New List</v-card-title>
		        <v-divider></v-divider>
		        <v-card-text class="pt-4 body-2">
		        	<v-text-field v-if="createListDialog"
		        		@keyup.enter="createList"
		        		autofocus
	        			label="List Name"
	        			v-model="newListName">
			        </v-text-field>
		        </v-card-text>
		        <v-card-actions>
		          	<v-spacer></v-spacer>
		          	<v-btn color="green darken-1" flat v-if="newListName"
		          		@click.native="createList">Create
		      	 	 </v-btn>	
		      	 	 <v-btn color="green darken-1" flat @click.native="createListDialog=false">Cancel</v-btn>		          					      	 	
		        </v-card-actions>
	      	</v-card>
    	</v-dialog>

	</v-container>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Vue from 'vue'
import DBToggleBtn from '@/components/DBToggleBtn'
import EmployeeAutocomplete from '@/components/forms/EmployeeAutocomplete'
import HelpRoomAmenities from '@/components/help/HelpRoomAmenities2'
import XLSX from 'xlsx'

export default {
data () {
	return {
		reset: 1,
		showPurgeDialog: false,
		showDeleteAndPurgeDialog: false,
		showChangeOwner: false,
		showChangeEditors: false,
		resetEditorAutoComplete: 1000,
		drawerMenu: false,
		createListDialog: false,
		newListName: null,
		listOfLists: [{listname: 'Loading...'}],
		amenitiesListDefinition: null,
		changed: false,
		permissionsChanged: false,
		selectedList: null,
		dataTypes: ['Boolean', 'Number', 'Integer', 'Allowed Values', 'Date', 'String' ],
	}
},

created: async function () {
	this.listOfLists = await this.fetchAmenitiesListOfLists()
	//console.log(this.listOfLists)
},

components: { DBToggleBtn, EmployeeAutocomplete, HelpRoomAmenities },

watch: {
		async useDevDatabase (val) { this.listOfLists = await this.fetchAmenitiesListOfLists() } ,
		employeeID (val) { if (val == "") { this.$router.push('/') } } //If user is not an employee, redirect
},

computed: {
	...mapState({   	darkTheme: 		state => state.ui.darkTheme,
						useDevDatabase: state => state.ui.useDevDatabase,
						employeeID:     state => state.user.userProfile.employeeID,		}),

	getEditors: function () {
		return this.amenitiesListDefinition.editors.map((employee) => { return (' ' + employee.name)  })
	},

	sortedItems: function () {
		return this.amenitiesListDefinition.list.sort((a, b) => (a.order > b.order) ? 1 : -1)

	}
},

methods : {
	...mapMutations([ 	'setSnackText', 'setShowHelpRoomAmenities2', 								]),	
	...mapActions([		'fetchAmenitiesListOfLists', 'fetchAmenitiesList', 
						'updateAmenitiesListDefinition', 'deleteAmenitiesList',
						'createAmenitiesList', 'clearRoomAmenitiesData', 'fetchAmenityListRoomData',
				]),

	toggleMenu: function () {
		this.drawerMenu = !this.drawerMenu
	},

	

	setOwner(value) {
		console.log("SetOwner: ", value.name)
		this.amenitiesListDefinition.employeeID = value.employeeID
		this.amenitiesListDefinition.name = value.name
		this.permissionsChanged=true
		this.showChangeOwner = false
	},

	addEditor(value) {
		this.amenitiesListDefinition.editors.push(value)
		this.permissionsChanged=true
		this.resetEditorAutoComplete=this.resetEditorAutoComplete + 1
	},

	removeEditor(index) {
		this.amenitiesListDefinition.editors.splice(index,1)
		this.permissionsChanged=true
	},

	deleteItem: function (index) {
		this.amenitiesListDefinition.list.splice(index, 1)
		this.changed = true
	},

	addLine: function (item) {
		if (item && item.dataType=="Allowed Values") {
			item.allowedValues.push({ value: null })
		} else {
			// Get the current max order from the list
			let nextOrder = 0
			this.amenitiesListDefinition.list.forEach((item) => {
				if (item.order > nextOrder) { nextOrder = item.order }  
			})
			nextOrder = nextOrder + 100
			this.amenitiesListDefinition.list.push({ order: nextOrder, label: null, dataType: null, allowedValues: [] })
		}
		this.changed = true
	},

	addAllowedValue: function (item) {
		item.allowedValues.push({ value: null })
		this.changed = true
	},

	deleteAllowedValue: function (item, index) {
		item.allowedValues.splice(index, 1)
		this.changed = true
	},

	createList: async function () {
		await this.createAmenitiesList({ listname: this.newListName, owner: 'drennen' })		
		this.listOfLists = await this.fetchAmenitiesListOfLists()
		this.selectedList = this.listOfLists.find((list) => list.listname == this.newListName )
		this.listChanged()
		this.newListName = null
		this.createListDialog=false
	},

	listChanged: async function () {
		this.amenitiesListDefinition = await this.fetchAmenitiesList({ key: this.selectedList.key })
		this.addOrderingToData()
		this.$nextTick(() => { this.$refs.addRowBtn.$el.focus() }) // Set focus on button notice the $el
	},

	// Add ordering.  This adds ordering if it is not present
	addOrderingToData: function () {
		let counter = 0
		if (this.amenitiesListDefinition.list[0] && this.amenitiesListDefinition.list[0].order) { return }  // return if ordering is present
		
		console.log("Adding Ordering")
		this.amenitiesListDefinition.list.forEach((item) => {
			counter += 100
			item.order = counter 
		})
	},

	changeOrder: function(index, direction) {		
		//console.log("change Order", index, direction)
		let prevItem 	= this.amenitiesListDefinition.list[index - 1]		
		let item 		= this.amenitiesListDefinition.list[index]		
		let nextItem 	= this.amenitiesListDefinition.list[index + 1]	
		
		if (direction == "up" && prevItem) {
			this.changed = true			
			let thisOrder = item.order.valueOf()		// valueOf should copy without making pointer
			let prevOrder = prevItem.order.valueOf()
			
			item.order = prevOrder		// set this item's order to prevorder
			prevItem.order = thisOrder  // set previous item's order to this order.  Swap them.

			// Use set to trigger reactivity
			Vue.set(this.amenitiesListDefinition.list, index-1, prevItem)
			Vue.set(this.amenitiesListDefinition.list, index, item)
			

		} else if (direction == "down" && nextItem) {
			this.changed = true
			let thisOrder = item.order.valueOf()
			let nextOrder = nextItem.order.valueOf()
			item.order = nextOrder
			nextItem.order = thisOrder

			// Use set to trigger reactivity
			Vue.set(this.amenitiesListDefinition.list, index, item)
			Vue.set(this.amenitiesListDefinition.list, index+1, nextItem)
		}
	},

	submit: async function () {  
		let payload = this.amenitiesListDefinition 
		console.log(payload)
		let response = await this.updateAmenitiesListDefinition(payload)
		this.setSnackText(response)
		this.changed = false
		this.permissionsChanged=false
		this.drawerMenu = false			
		this.showChangeEditors = false
		this.showChangeOwner = false
		this.amenitiesListDefinition = await this.fetchAmenitiesList({ key: this.selectedList.key })
	},

	deleteListDefinition: async function () {
		console.log("Delete List Definition and Clear All Data")
		await this.deleteAmenitiesList({ key: this.amenitiesListDefinition.key })
		this.cancel()	
	},

	clearRoomData: async function () {
		await this.clearRoomAmenitiesData({ key: this.amenitiesListDefinition.key })
		this.cancel()
	},

	cancel: async function () {
		this.changed = false
		this.permissionsChanged=false
		this.drawerMenu = false			
		this.showChangeEditors = false
		this.showChangeOwner = false
		this.amenitiesListDefinition = null
		this.listOfLists = await this.fetchAmenitiesListOfLists()	
		this.selectedList = null
	},

	showHelp: function () {
        this.setShowHelpRoomAmenities2(true)
    },
	exportTable: async function () {
	      	// Create workbook
	      	const wb = XLSX.utils.book_new() 

	      	// Create worksheet, and add info
	      	let ws = XLSX.utils.aoa_to_sheet([
						[`UArizona Interactive Floorplans - ${this.amenitiesListDefinition.listname}`]						
					])
					
			let roomData = await this.fetchAmenityListRoomData(this.amenitiesListDefinition)
		
	      	XLSX.utils.sheet_add_json(ws, roomData, { origin:"A4" })

			// Column Widths
			var wscols = [
				    {wch:10},
				    {wch:10},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
				    {wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
					{wch:30},
				];

			ws['!cols'] = wscols;

	      
	      	// add Worksheet to Workbook
	        XLSX.utils.book_append_sheet(wb, ws, `${this.amenitiesListDefinition.listname}`)

	      	// export Excel file
	      	XLSX.writeFile(wb, `RoomAmenities-${this.amenitiesListDefinition.listname}.xlsx`) 

	    },
},

}

</script>

<style>
.fullpage {
	display: absolute;
	flex-direction: column;
	flex: 1;
	z-index: 10;
	position: fixed;
	top: 0px;
	width: 100vw;
	background-color: rgba(255, 255, 255, 1);
	padding: 0px !important;
	margin-top: 0px;
	height: 100%;
	overflow: hidden;
}

.topTitle {
	font-family: 'Open Sans', sans-serif;
	font-size: 25px;
}

.blocka {
  height: 45px;
  margin-right: 20px;
  margin-left: 20px;
  float: left;
}

.toplayoutRAListEditor {
	height: 80px;  /* This sets height of upper section.  Lower section gets the rest */
	/*height: 40%;	 This is also possible */
}

.bottomlayoutRAListEditor {		/* Make sure to subtract the height of toplayout */
	height: calc(100% - 80px);
	/*height: 60%;	 This is also possible */
}

.RAListOverflow {		/* This sets the list's height to 100% of the card minus other objects.  In this case toolbar (64px) */
	overflow-y: auto;
	margin-bottom: 100px;
	padding-right: 20px;
	/*height: calc(50% - 180px);*/  
}


</style>



// WEBPACK FOOTER //
// src/components/roomAmenities/AmenitiesListEditor.vue